import { BlogTheme } from "@types"

import { ThemeColor, THEME_COLORS } from "@types"

/**
 * Re-export these here to explicitly
 * keep all theming logic in this file.
 */
export { THEME_COLORS }
export type { ThemeColor }

/**
 * Helper function to get the class name and styles
 * for the colors and fonts for a blog.
 *
 * The actual CSS colors and fonts are listed in app/theme.scss.
 */
export function getBlogTheme(theme?: BlogTheme) {
  const headerFont =
    theme?.headerFont === "default" ? "sans" : theme?.headerFont || "sans"
  const bodyFont =
    theme?.bodyFont === "default" ? "sans" : theme?.bodyFont || "sans"

  const blogThemeColor = theme?.color || "default"

  return `theme-${blogThemeColor} paragraph-custom-theme paragraph-color-${blogThemeColor} theme-header-${headerFont} theme-body-${bodyFont} header-font-${headerFont} body-font-${bodyFont}`
}
